import './news-feed.scss';
import { setupLayout } from '../Shared/layout';
import * as $ from 'jquery';
import 'owl.carousel/dist/owl.carousel';

setupLayout();

$(document).ready(function () {
    $('.owl-newsFeed').owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        dots: true,
        responsive: {
            0: {
                items: 1
            },
            //426: {
            //    items: 2
            //},
            // 1025: {
            //     items: 2
            // }
        }
    });
});